import * as React from 'react'
import { Link } from 'react-router-dom'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type JobLevel from 'modules/job_catalog/store/models/JobLevel'
import type JobRole from 'modules/job_catalog/store/models/JobRole'

interface Props {
  jobCatalogLevel?: JobLevel
  jobCatalogRole?: JobRole
}

const CurrentPosition = ({ jobCatalogLevel, jobCatalogRole }: Props) => {
  const { navigation } = useNavigation()
  const result: string[] = []

  const jobRole = jobCatalogRole?.attributes.name
  if (jobRole) result.push(jobRole)

  const jobLevel = jobCatalogLevel?.attributes.is_default ? '' : jobCatalogLevel?.attributes.name
  if (jobLevel) result.push(jobLevel)
  const position = result.join(', ')

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.job_position.current_position')}
      </Text>
      <Link to={navigation.employees.jobCatalog.fullPath()}>
        <Box gap="s8" flexDirection="row" alignItems="center">
          {position && (
            <Text size="400" weight="medium" color="grey1000">
              {position}
            </Text>
          )}
          {!position && (
            <Text size="400" weight="medium" color="grey600">
              {i18n.t('contract_versions.job_position.not_informed')}
            </Text>
          )}
          <Icon.Medium icon="arrow-right" color="grey800" />
        </Box>
      </Link>
    </Box>
  )
}
export default observer(CurrentPosition)
